import type { SVGProps } from 'react';
const DawnFlagZW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-ZW_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-ZW_svg__a)">
      <path
        fill="#369D0C"
        fillRule="evenodd"
        d="M0 2.133h22V0H0zM0 16h22v-2.133H0zM0 6.4h22V4.267H0zM0 11.733h22V9.6H0z"
        clipRule="evenodd"
      />
      <path fill="#262626" fillRule="evenodd" d="M0 9.6h22V6.4H0z" clipRule="evenodd" />
      <path
        fill="#FFD40E"
        fillRule="evenodd"
        d="M0 4.267h22V2.133H0zM0 13.867h22v-2.134H0z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        stroke="#262626"
        strokeWidth={1.333}
        d="m9.378 8-9.604 7.333H-.38V.667h.155z"
      />
      <path
        fill="url(#dawn-flag-ZW_svg__b)"
        fillRule="evenodd"
        d="m3.142 9.04-1.539 1.117.568-1.836-1.52-1.145 1.891-.017.6-1.826.6 1.826 1.891.017-1.52 1.145.569 1.836z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-ZW_svg__b"
        x1={0.523}
        x2={0.523}
        y1={5.333}
        y2={10.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F12F1F" />
        <stop offset={1} stopColor="#DE2010" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagZW;
